// extracted by mini-css-extract-plugin
export default {"root":"ChangePassword_root__bY64G","title":"ChangePassword_title__URYWg"};